<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
        <a-row :gutter="24">
          <a-col :sm="24" :md="8" :lg="8" :xl="6" :xxl="5">
            <a-form-model-item label="关键字">
              <a-input
                :placeholder="this.$t('disp.ph.input', [$t('disp.flow.modelName')])"
                v-model="queryParam.searchText"
              ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="1" :sm="1" class="width-fit-content">
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                this.$t('disp.btn.search')
              }}</a-button>
              <a-button @click="searchReset" icon="stop">{{ this.$t('disp.btn.reset') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 検索区域-end -->

    <!-- ボタン操作区域-begin -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ this.$t('disp.btn.add') }}</a-button>

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="handleDeployBatch">
            <a-icon type="play-circle" />
            {{ $t('disp.btn.deploy') }}
          </a-menu-item>
          <a-menu-item key="2" @click="handleUndeployBatch">
            <a-icon type="pause-circle" />
            {{ $t('disp.btn.cancelDeploy') }}
          </a-menu-item>
          <a-menu-item key="3" @click="handleRemoveMenuBatch">
            <a-icon type="undo" />
            {{ $t('disp.btn.cancelForm') }}
          </a-menu-item>
          <a-menu-item key="4" @click="handleDeleteBatch">
            <a-icon type="close" />
            {{ $t('disp.btn.delete') }}
          </a-menu-item>
        </a-menu>
        <a-button>
          <a-icon type="down" />
          {{ $t('disp.btn.operationBatch') }}
        </a-button>
      </a-dropdown>
    </div>
    <!-- ボタン操作区域-end -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>

        <!--<div style="float: right">
          <a-popconfirm
            title="该操作会清空所有已发起的流程实例（非流程定义），请务必谨慎"
            @confirm="() => handleInit()"
            v-if="$getLoginUser().editableFlag == '1'"
          >
            <a>清空流程实例</a>
          </a-popconfirm>
        </div>-->
      </div>

      <a-table
        ref="table"
        rowKey="modelId"
        class="action"
        tableLayout="auto"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <!-- 流程定义ID -->
        <div slot="modelId" slot-scope="text, record">
          <a @click="handleEdit(record.modelId)">{{ record.modelId }}</a>
        </div>

        <!-- プロセス類別 -->
        <span slot="wfType" slot-scope="text, record">
          {{ $getDict('wf_type', record.wfType ? record.wfType : '0') }}
        </span>

        <!-- 開始日 -->
        <span slot="startDate" slot-scope="text, record">
          <span v-if="record.startDate">{{ moment(record.startDate).format('YYYY-MM-DD') }}</span>
          <j-empty v-else></j-empty>
        </span>

        <!-- 終了日 -->
        <span slot="endDate" slot-scope="text, record">
          <span v-if="record.endDate">{{ moment(record.endDate).format('YYYY-MM-DD') }}</span>
          <j-empty v-else></j-empty>
        </span>

        <!-- 進行中案件数 -->
        <div slot="activeCnt" slot-scope="text, record">
          <div v-if="record.activeCnt > 0">
            <a class="activeCnt" @click="handleTransfer(record)">{{ record.activeCnt }}</a>
          </div>
        </div>

        <!-- 発行日時 -->
        <span slot="deployTime" slot-scope="text, record">
          <span v-if="record.deployTime">
            <div style="white-space: nowrap">
              {{ moment(record.deployTime).format('YYYY-MM-DD') }}
            </div>
            <span class="note">
              {{ moment(record.deployTime).format(' HH:mm:ss') }}
            </span>
          </span>
        </span>

        <!-- 関連フォーム -->
        <div slot="menu" slot-scope="text, record">
          <!--<a-tag color="blue" v-if="record.relationMenuId != null && record.relationMenuId != ''">{{
            $t('disp.flow.related')
          }}</a-tag>-->
          <a-icon
            type="check"
            v-if="record.relationMenuId != null && record.relationMenuId != ''"
            style="color: var(--color-green); font-size: 14px"
          ></a-icon>
        </div>

        <!-- ステータス -->
        <div slot="status" slot-scope="text, record">
          <a-tag color="orange" v-if="record.deploymentId == null">{{ $t('disp.flow.undeployed') }}</a-tag>
          <a-tag color="red" v-else-if="moment(record.lastUpdateTime) - moment(record.deployTime) > 3000">{{
            '更新后未发布'
          }}</a-tag>
          <a-tag color="green" style="letter-spacing: 1px" v-else>{{
            $t('disp.flow.deployed') + ':' + record.deploymentId
          }}</a-tag>
        </div>

        <!-- 操作 -->
        <div slot="action" slot-scope="text, record" style="width: 100%; text-align: left">
          <a @click="handleEdit(record.modelId)">{{ $t('disp.btn.edit') }}</a>

          <a-divider type="vertical" />
          <a @click="handleCopy(record.modelId)">{{ $t('disp.btn.copy') }}</a>

          <a-divider type="vertical" v-if="record.relationMenuId == null || record.relationMenuId == ''" />
          <a @click="handleRelateMenu(record)" v-if="record.relationMenuId == null || record.relationMenuId == ''">{{
            $t('disp.flow.relateForm')
          }}</a>

          <a-divider type="vertical" v-if="record.relationMenuId != null && record.relationMenuId != ''" />
          <a @click="handleRelateMenu(record)" v-if="record.relationMenuId != null && record.relationMenuId != ''">{{
            $t('disp.flow.changeForm')
          }}</a>

          <a-divider
            type="vertical"
            v-if="record.relationMenuId != null && record.relationMenuId != '' && record.deploymentId == null"
          />
          <a-popconfirm
            :title="$t('msg.flow.confirm.cancel')"
            @confirm="() => handleRemoveMenu(record)"
            v-if="record.relationMenuId != null && record.relationMenuId != '' && record.deploymentId == null"
          >
            <a>{{ $t('disp.btn.cancelForm') }}</a>
          </a-popconfirm>

          <a-divider
            type="vertical"
            v-if="
              (record.deploymentId == null || moment(record.lastUpdateTime) - moment(record.deployTime) > 3000) &&
              record.relationMenuId != null &&
              record.relationMenuId != ''
            "
          />
          <a
            @click="handleDeploy(record.modelId)"
            v-if="
              (record.deploymentId == null || moment(record.lastUpdateTime) - moment(record.deployTime) > 3000) &&
              record.relationMenuId != null &&
              record.relationMenuId != ''
            "
            >{{ $t('disp.btn.deploy') }}</a
          >

          <a-divider type="vertical" v-if="record.deploymentId != null && record.activeCnt == 0" />
          <a-popconfirm
            v-if="record.deploymentId != null && record.activeCnt == 0"
            :title="$t('msg.confirm.undeploy')"
            @confirm="() => handleUndeploy(record.deploymentId, record.relationMenuId)"
          >
            <a>{{ $t('disp.btn.cancelDeploy') }}</a>
          </a-popconfirm>

          <a-divider type="vertical" v-if="!record.deploymentId && record.activeCnt == 0" />
          <a-popconfirm
            :title="$t('msg.confirm.delete')"
            @confirm="() => handleDelete(record.modelId)"
            v-if="!record.deploymentId && record.activeCnt == 0"
          >
            <a>{{ $t('disp.btn.delete') }}</a>
          </a-popconfirm>

          <!--<a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>

            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleCopy(record.modelId)">{{ $t('disp.btn.copy') }}</a>
              </a-menu-item>

              <a-menu-item v-if="record.relationMenuId == null || record.relationMenuId == ''">
                <a @click="handleRelateMenu(record)">{{ $t('disp.flow.relateForm') }}</a>
              </a-menu-item>

              <a-menu-item v-if="record.relationMenuId != null && record.relationMenuId != ''">
                <a @click="handleRelateMenu(record)">{{ $t('disp.flow.changeForm') }}</a>
              </a-menu-item>

              <a-menu-item
                v-if="record.relationMenuId != null && record.relationMenuId != '' && record.deploymentId == null"
              >
                <a-popconfirm :title="$t('msg.flow.confirm.cancel')" @confirm="() => handleRemoveMenu(record)">
                  <a>{{ $t('disp.btn.cancelForm') }}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item
                v-if="
                  (record.deploymentId == null || moment(record.lastUpdateTime) - moment(record.deployTime) > 3000) &&
                  record.relationMenuId != null &&
                  record.relationMenuId != ''
                "
              >
                <a @click="handleDeploy(record.modelId)">{{ $t('disp.btn.deploy') }}</a>
              </a-menu-item>

              <a-menu-item v-if="record.deploymentId != null && record.activeCnt == 0">
                <a-popconfirm
                  :title="$t('msg.confirm.undeploy')"
                  @confirm="() => handleUndeploy(record.deploymentId, record.relationMenuId)"
                >
                  <a>{{ $t('disp.btn.cancelDeploy') }}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="!record.deploymentId && record.activeCnt == 0">
                <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.modelId)">
                  <a>{{ $t('disp.btn.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </div>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- bpmn編集区域-begin -->
    <modeler-modal ref="ModelerModal" @modelerSaved="modelerSaved"></modeler-modal>
    <!-- bpmn編集区域-end -->

    <!-- 関連フォーム-begin -->
    <relate-menu-modal ref="RelateMenuModal" @menuSaved="menuSaved"></relate-menu-modal>
    <!-- 関連フォーム-end -->
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { putAction, postAction, getAction, deleteAction } from '@/api/manage'
import ModelerModal from './modules/ModelerModal'
import RelateMenuModal from './modules/RelateMenuModal'

export default {
  name: 'ModelManage',
  mixins: [tableMixin],
  components: {
    ModelerModal,
    RelateMenuModal,
  },
  mounted() {
    window.vm = this
  },
  data() {
    return {
      description: 'プロセス定義管理',
      showLoadingBySearch: false,
      deployBtn: false,
      bpmnList: [],
      bpmnVisible: false,
      bpmnFile: '',
      opType: '',
      // 検索条件
      queryParam: {},
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.modelId'),
          align: 'left',
          dataIndex: 'modelId',
          scopedSlots: { customRender: 'modelId' },
        },
        {
          title: this.$t('disp.flow.modelName'),
          dataIndex: 'modelName',
        },
        // {
        //   title: 'KEY',
        //   align: 'center',
        //   dataIndex: 'key'
        // },
        // {
        //   title: this.$t('disp.flow.applyKey'),
        //   width: 150,
        //   dataIndex: 'key'
        // },
        {
          title: this.$t('disp.flow.applyType'),
          align: 'left',
          scopedSlots: { customRender: 'wfType' },
        },
        {
          title: '表单',
          dataIndex: 'component',
        },
        // {
        //   title: this.$t('disp.flow.applyName'),
        //   dataIndex: 'name'
        // },
        {
          title: '使用' + this.$t('disp.flow.process.startDate'),
          align: 'left',
          scopedSlots: { customRender: 'startDate' },
        },
        {
          title: '使用' + this.$t('disp.flow.process.endDate'),
          align: 'left',
          scopedSlots: { customRender: 'endDate' },
        },
        //{
        //  title: this.$t('disp.flow.relatedForm'),
        //  align: 'center',
        //  width: 100,
        //  scopedSlots: { customRender: 'menu' },
        //},
        {
          title: '排序',
          align: 'center',
          width: 100,
          dataIndex: 'sortNo',
        },
        {
          title: '进行中流程数',
          align: 'center',
          scopedSlots: { customRender: 'activeCnt' },
        },
        {
          title: '发布时间',
          align: 'left',
          scopedSlots: { customRender: 'deployTime' },
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/model/list',
        init: '/flow/model/init',
        copy: '/flow/model/copy',
        modelToMenu: '/flow/model/modelToMenu',
        removeMenu: '/flow/model/removeMenu',
        removeMenuBatch: '/flow/model/removeMenuBatch',
        deploy: '/flow/deploy',
        deployBatch: '/flow/deployBatch',
        undeploy: '/flow/undeploy',
        undeployBatch: '/flow/undeployBatch',
        delete: '/flow/model/delete',
        deleteBatch: '/flow/model/deleteBatch',
        getMenu: '/blaze-sys/k00/k0005/MenuManage/getById',
      },
    }
  },
  computed: {},
  methods: {
    moment,
    handleAdd() {
      this.$refs.ModelerModal.createModel()
    },
    handleEdit(modelId) {
      this.$refs.ModelerModal.editModel(modelId)
    },
    handleInit() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.init, {})
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete(modelId) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.delete, { modelId: modelId })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDeleteBatch: function () {
      var modelIds = ''
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
        modelIds += this.selectedRowKeys[a] + ','
      }
      var that = this
      this.$confirm({
        title: this.$t('disp.warn'),
        content: this.$t('msg.confirm.deleteBatch'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          postAction(that.url.deleteBatch, { modelIds: modelIds })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.searchQuery(true, false)
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    handleCopy(modelId) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.copy, { modelId: modelId })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDeploy(modelId) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.deploy, { modelId: modelId })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDeployBatch: function () {
      var modelIds = ''
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
        modelIds += this.selectedRowKeys[a] + ','
      }
      var that = this
      this.$confirm({
        title: this.$t('disp.warn'),
        content: this.$t('disp.confirm.deployBatch'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          postAction(that.url.deployBatch, { modelIds: modelIds })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.searchQuery(true, true)
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    handleUndeploy(deploymentId, relationMenuId) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.undeploy, {
        deploymentId: deploymentId,
        relationMenuId: relationMenuId,
      })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleUndeployBatch: function () {
      var modelIds = ''
      var relationMenuIds = ''
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
        // 発行中 且つ 進行中案件数が0件のレコードのみが対象
        if (this.selectionRows[a].deploymentId != null && this.selectionRows[a].activeCnt == 0) {
          modelIds += this.selectedRowKeys[a] + ','
          relationMenuIds += this.selectionRows[a].relationMenuId + ','
        }
      }
      var that = this
      this.$confirm({
        title: this.$t('disp.warn'),
        content: this.$t('msg.confirm.undeployBatch'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          postAction(that.url.undeployBatch, {
            modelIds: modelIds,
            relationMenuIds: relationMenuIds,
          })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.searchQuery(true, true)
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    handleRelateMenu(record) {
      this.$refs.RelateMenuModal.name = record.modelName
      this.$refs.RelateMenuModal.perms = 'flow:model:' + record.modelId
      this.$refs.RelateMenuModal.modelId = record.modelId
      if (record.relationMenuId) {
        getAction(this.url.getMenu, { id: record.relationMenuId }).then((res) => {
          if (res.success) {
            this.opType = 'edit'
            this.$refs.RelateMenuModal.title = this.$t('disp.btn.edit')
            this.$refs.RelateMenuModal.alwaysShow = res.result.alwaysShow
            this.$refs.RelateMenuModal.phoneShow = res.result.phoneShow
            this.$refs.RelateMenuModal.edit(res.result)
          }
        })
      } else {
        this.opType = 'add'
        this.$refs.RelateMenuModal.title = this.$t('disp.btn.add')
        this.$refs.RelateMenuModal.add()
      }
    },
    handleRemoveMenu(record) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      putAction(this.url.removeMenu, { modelId: record.modelId })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleRemoveMenuBatch: function () {
      var modelIds = ''
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
        modelIds += this.selectedRowKeys[a] + ','
      }
      var that = this
      this.$confirm({
        title: this.$t('disp.warn'),
        content: this.$t('disp.confirm.cancelFormBatch'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          putAction(that.url.removeMenuBatch, { modelIds: modelIds })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.searchQuery(true, true)
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    modelerSaved() {
      this.searchQuery(true, true)
    },
    menuSaved(menuUid, modelId) {
      if (this.opType == 'add') {
        putAction(this.url.modelToMenu, { modelId: modelId, menuUid: menuUid }).then((res) => {
          if (res.success) {
            this.searchQuery(true, true)
          }
        })
      } else {
        this.searchQuery(true, true)
      }
    },
    handleTransfer(record) {
      this.$router.push({
        name: 'k00-k0011-ProcessInstanceManage',
        params: { name: record.modelName, modelId: record.modelId },
      })
    },
  },
}
</script>
<style scoped lang="less">
.ant-tag {
  font-size: 12px;
}
</style>
